import { render, staticRenderFns } from "./productcategories.vue?vue&type=template&id=486f2d16&"
import script from "./productcategories.vue?vue&type=script&lang=js&"
export * from "./productcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports